export const isOlderThanXDays = (dateString: string, days: number) => {
	// Convert the string to a Date object
	const date = new Date(dateString)

	// Get the current date
	const now = new Date()

	// Calculate the difference in milliseconds
	const differenceInMs = now.getTime() - date.getTime()

	// Convert milliseconds to days
	const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24)

	// Check if the difference is greater than 30 days
	return differenceInDays > days
}

export const isOlderThanNow = (date: Date) => {
	const now = new Date()
	return now.getTime() - date.getTime() >= 0
}

export const addDays = (date: Date, days: number) => {
	const newDate = new Date(date)
	newDate.setDate(newDate.getDate() + days)
	return newDate
}

export const subtractDays = (date: Date, days: number) => {
	const newDate = new Date(date)
	newDate.setDate(newDate.getDate() - days)
	return newDate
}

export const addMonths = (date: Date, months: number) => {
	const newDate = new Date(date)
	newDate.setMonth(newDate.getMonth() + months)
	return newDate
}
